import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Store base class
 */
export abstract class Store<T> {
  // tslint:disable-next-line: variable-name
  protected readonly _state$: BehaviorSubject<T>;
  public readonly state$: Observable<T>;

  protected constructor(protected readonly initialState: T, protected scope = 'App') {
    this._state$ = new BehaviorSubject(this.initState());
    this.state$ = this._state$.asObservable();
  }

  get state(): T {
    return this._state$.getValue();
  }

  set state(next: T) {
    this._state$.next(next);
  }

  reset() {
    this.state = this.initState();
  }

  initState(): T {
    return JSON.parse(localStorage.getItem(this.scope)) || this.initialState;
  }

  getState(): BehaviorSubject<T> {
    return this._state$;
  }

  saveState() {
    localStorage.setItem(this.scope, JSON.stringify(this.state));
  }

  cleanState() {
    localStorage.removeItem(this.scope);
  }
}
